import React from 'react';
import { Section } from '../ui/Section';
import { Clock } from 'lucide-react';
export function Urgencia() {
  return <Section background="dark" className="text-center" data-id="element-299">
      <div className="inline-flex items-center gap-2 bg-amber-500/20 text-amber-300 border border-amber-500/30 px-4 py-1.5 rounded-full text-sm font-semibold mb-6" data-id="element-300">
        <Clock className="w-4 h-4" data-id="element-301" />
        Precio de lanzamiento
      </div>

      <p className="text-xl md:text-2xl text-white font-medium mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-302">
        El precio actual es{' '}
        <span className="text-amber-400 font-bold" data-id="element-303">ARS 9.990</span> + los 3
        bonos gratis.
        <br className="hidden md:block" data-id="element-304" />
        Cuando cierre el lanzamiento, los bonos se retiran y el precio vuelve a
        ARS 14.990.
      </p>

      <div className="bg-stone-800/50 p-6 rounded-xl inline-block border border-stone-700" data-id="element-305">
        <p className="text-stone-400" data-id="element-306">
          No hay cuenta regresiva falsa.
          <br data-id="element-307" />
          <span className="text-white font-medium" data-id="element-308">Cuando cambie, cambia.</span>
        </p>
      </div>
    </Section>;
}